<template>
  <app-layout>
    <div class="flex flex-col items-center py-4">
      <div class="w-full px-12">
        <div class="flex flex-row items-center py-4">
          <h1 class="text-lg font-bold">Órdenes <span v-if="client">de {{ this.client }}</span></h1>
          <div class="flex flex-row ml-auto">
            <sa-button type="secondary" class="items-center py-3 font-bold rounded" data-tour="agregar-estatus" @click="$router.push({
              name: 'administration.orderPreferences',
              params: { scrollToElementInSlot: 'orderStatusConfigRef' },
            })">
              Agregar Estatus
            </sa-button>
            <sa-button :disabled="!$store.state.account.canCreateOrders" type="primary"
              class="items-center px-3 py-3 font-bold rounded" @click="handleCreateOrderClick">
              Crear orden
            </sa-button>
          </div>
        </div>
        <div class="flex flex-col space-y-6">
          <content-card>
            <orders-list :outerStatus="status" :is-mobile="isMobile" @loaded="onOrdersLoaded" />
          </content-card>
        </div>
      </div>
    </div>
    <onboarding-configure-business :show="showConfigureModal" @close="onCloseConfigure" @open-settings="openSettings" />
  </app-layout>
</template>

<script>
import AppLayout from "@/components/layouts/AppLayout.vue";
import ContentCard from "@/components/molecules/ContentCard.vue";
import OrdersList from "@/views/app/orders/OrdersList.vue";
import responsiveSize from '@/mixins/responsiveSize';
import OnboardingConfigureBusiness from '@/components/dialogs/Onboarding/components/5-onboarding.vue';
import { driver } from 'driver.js';

export default {
  name: "OrdersIndex",
  mixins: [responsiveSize],
  components: {
    AppLayout,
    ContentCard,
    OrdersList,
    OnboardingConfigureBusiness,
  },
  data() {
    return {
      client: false,
      isMobile: false,
      status: 'all',
      tourPending: false,
      showConfigureModal: false,
    };
  },
  mounted() {
    const status = this.$route.params.status;
    if (status) {
      this.status = status;
    }

    const client = this.$route.params.client;
    if (client) {
      this.client = client;
    }

    const fromOnboarding = this.$route.query.from_onboarding;

    if (fromOnboarding) {
      this.tourPending = true;
      // Abrimos el dropdown inmediatamente desde mounted
      this.$nextTick(() => {
        const menu = document.getElementById('quick-actions-menu');
        if (menu) menu.click();
      });
    }
  },
  created() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    onOrdersLoaded() {
      if (this.tourPending) {
        this.tourPending = false;
        this.startTour();
      }
    },
    onCloseConfigure() {
      this.showConfigureModal = false;
    },
    async openSettings(section, subsection) {
      this.showConfigureModal = false;

      const routeName = `administration.${section}`;

      if (!subsection) {
        this.$router.push({ name: routeName }).catch(() => { });
        return;
      }

      try {
        await this.$router.push({ name: routeName, params: { scrollToElementInSlot: subsection } });
      } catch (e) {
        // ignore navigation errors
      }

      let handled = false;

      const onScrolled = (refName) => {
        if (refName === subsection) {
          handled = true;
        }
      };

      this.$root.$once('admin-scrolled-to', onScrolled);

      setTimeout(() => {
        if (!handled) {
          this.$router.replace({ name: routeName }).catch(() => { });
        }
      }, 700);
    },
    resize() {
      const percentageWidth = this.getPercentageWidth();
      this.isMobile = percentageWidth === '90%';
    },
    handleCreateOrderClick() {
      if (this.$store.state.business.id) {
        this.$router.push({ name: 'orders.create' });
      } else {
        this.$toastr.i("Tienes que estar en una sucursal para poder crear ordenes");
      }
    },
    startTour() {
      const waitForElement = (selector, callback) => {
        const el = document.querySelector(selector);
        if (el && el.offsetParent !== null) {
          callback();
        } else {
          setTimeout(() => waitForElement(selector, callback), 100);
        }
      };

      waitForElement('[data-tour="crear-orden"]', () => {
        const driverObj = driver({
          allowClose: false,
          nextBtnText: 'Siguiente →',
          prevBtnText: '← Anterior',
          doneBtnText: 'Entendido',
          onDestroyStarted: () => {
            driverObj.destroy();
            const q = { ...this.$route.query };
            delete q.from_onboarding;
            this.$router.replace({ query: q }).catch(() => { });
            this.showConfigureModal = true;
          }
        });

        driverObj.setSteps([
          {
            element: '[data-tour="crear-orden"]',
            popover: {
              title: 'Crear Orden',
              description: 'Desde aquí puedes crear una nueva orden rápidamente.',
              side: 'bottom',
              onNextClick: () => {
                const m = document.getElementById('quick-actions-menu');
                if (m) m.click();
                driverObj.moveNext();
              }
            }
          },
          {
            element: '[data-tour="agregar-estatus"]',
            popover: {
              title: 'Agregar Estatus',
              description: 'Agrega estados personalizados para tu flujo de trabajo.',
              side: 'bottom',
              onPrevClick: () => {
                const m = document.getElementById('quick-actions-menu');
                if (m) m.click();
                waitForElement('[data-tour="crear-orden"]', () => {
                  driverObj.movePrevious();
                });
              }
            }
          },
          {
            element: '[data-tour="acciones-rapidas"]',
            popover: {
              title: 'Acciones Rápidas',
              description: 'Acciones rápidas para gestionar cada orden.',
              side: 'bottom'
            }
          },
        ]);

        driverObj.drive();
      });
    },
  }
};
</script>